<div class="executions-container">
  <div class="header-row">
    <h3>Executions (Last 14 Days)</h3>
    <div class="header-actions">
      <span class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input id="execSearch"
               pInputText type="text"
               [ngModel]="filterText"
               (input)="dt.filterGlobal($any($event.target).value, 'contains')"
               placeholder="Search Executions" />
      </span>
    </div>
  </div>


  <p-table
    #dt
    [value]="executions"
    [globalFilterFields]="['executionId','user','description']"
    [loading]="loading"
    responsiveLayout="scroll"
    [paginator]="false"
    [rows]="50"
    selectionMode="single"
    dataKey="executionId"
    [(selection)]="selectedExecution"
    [rowHover]="true"
    styleClass="exec-p-table p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-id">Execution ID</th>
        <th class="col-desc">Description</th>
        <th class="col-user">User</th>
        <th class="col-start">Start</th>
        <th class="col-complete">Complete</th>
        <th class="col-status">Status Summary</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [pSelectableRow]="row" class="clickable-row">
        <td class="col-id">{{ row.executionId }}</td>
        <td class="col-desc">{{ row.description }}</td>
        <td class="col-user">{{ row.user }}</td>
        <td class="col-start">
          <ng-container *ngIf="row.started; else noStart">
            <ng-container *ngIf="row.started.date; else startedSimple">{{ row.started.date.toLocaleString() | date: 'short' }}</ng-container>
            <ng-template #startedSimple>{{ row.started.toLocaleString() | date: 'short' }}</ng-template>
          </ng-container>
          <ng-template #noStart>-</ng-template>
        </td>
        <td class="col-complete">
          <ng-container *ngIf="row.completed; else noComplete">
            <ng-container *ngIf="row.completed.date; else completedSimple">{{ row.completed.date.toLocaleString() | date: 'short' }}</ng-container>
            <ng-template #completedSimple>{{ row.completed | date: 'short' }}</ng-template>
          </ng-container>
          <ng-template #noComplete>-</ng-template>
        </td>
        <td class="col-status">
          <div class="row-chips">
            <span class="chip chip-not-started">Not Started: <b>{{ row.notStarted || 0 }}</b></span>
            <span class="chip chip-in-progress">In Progress: <b>{{ row.inProgress || 0 }}</b></span>
            <span class="chip chip-succeeded">Succeeded: <b>{{ row.succeeded || 0 }}</b></span>
            <span class="chip chip-skipped">Skipped: <b>{{ row.skipped || 0 }}</b></span>
            <span class="chip chip-failed">Failed: <b>{{ row.failed || 0 }}</b></span>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty" colspan="6">No executions found.</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="summary-chips">
    <span class="chip chip-showing">Total Executions: <b>{{ totalExecutions }}</b></span>
    <span class="chip chip-not-started">Total Not Started: <b>{{ notStartedCount }}</b></span>
    <span class="chip chip-in-progress">Total In Progress: <b>{{ inProgressCount }}</b></span>
    <span class="chip chip-succeeded">Total Succeeded: <b>{{ succeededCount }}</b></span>
    <span class="chip chip-skipped">Total Skipped: <b>{{ skippedCount }}</b></span>
    <span class="chip chip-failed">Total Failed: <b>{{ failedCount }}</b></span>
  </div>
</div>
<auto-bulk-update-execution-detail
  [executionId]="selectedExecution?.executionId"
  [executionDescription]="selectedExecution?.description">
</auto-bulk-update-execution-detail>
